import React from 'react';
import { Image } from 'antd';
import { getFullBlobUrl } from '@app/utils/blobUrl';
import { IMAGE_FALLBACK } from '@app/components/image/imageFallback';

interface ProductItemThumbnailProps {
  imageUrl?: string | null;
  name?: string;
  size?: number;
}

/**
 * Ảnh sản phẩm trên dòng hàng của đơn — bấm vào xem to.
 *
 * Backend trả `image_url` có thể là đường dẫn tương đối (`/rails/active_storage/...`) khi chưa
 * đặt API_HOST, nên phải qua getFullBlobUrl; sản phẩm chưa có ảnh hoặc ảnh lỗi thì dùng ảnh mặc định.
 */
const ProductItemThumbnail: React.FC<ProductItemThumbnailProps> = ({ imageUrl, name, size = 40 }) => (
  <Image
    src={getFullBlobUrl(imageUrl ?? undefined) || IMAGE_FALLBACK}
    fallback={IMAGE_FALLBACK}
    alt={name}
    width={size}
    height={size}
    className="tw-rounded-md tw-object-cover"
    preview={{ mask: null }}
  />
);

export default ProductItemThumbnail;
